import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {isOutlookEnabled} from "../helpers/index";
import {CRMGetAttachmentMethodName, OutlookGetAttachmentMethodName} from "../helpers/methodNames";
import getAttachmentDictionary from "../dictionaries/GetAttachmentDictionary";

export const getAttachment = (agm: Glue42Core.AGM.API,
                              emailIds: Glue42Office.Outlook.T42Id[],
                              ids: Glue42Office.Outlook.T42Id[],
                              callback?: (percent: number) => number): Promise<string> =>
    new Promise((resolve, reject) => {
        if (!isOutlookEnabled(agm)) {
            reject(`The method "getAttachments" is not available`);
            return;
        }

        const cookie: string = new Date().getTime().toString();

        const successHandler = () => {
            getAttachmentDictionary.add(cookie, {callback, resolve, reject});
        };

        const errorHandler = (err: { message: string }) => {
            reject(err.message);
            return;
        };

        const getAttachmentOptions = {
            emailIds,
            attachmentIds: ids,
            callback: OutlookGetAttachmentMethodName,
            cookie,
        };

        return agm.invoke(CRMGetAttachmentMethodName, getAttachmentOptions)
            .then(() => successHandler())
            .catch((err: any) => errorHandler(err));
    });
